module.exports = __webpack_public_path__ + "img/5.c0bc2089.png";